import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _463c6b1f = () => interopDefault(import('../modules/micropage/index.vue' /* webpackChunkName: "micropage" */))
const _646feb4e = () => interopDefault(import('../pages/ara/index.vue' /* webpackChunkName: "pages/ara/index" */))
const _03d1d2c6 = () => interopDefault(import('../pages/ayarlar/index.vue' /* webpackChunkName: "pages/ayarlar/index" */))
const _2f01bfd6 = () => interopDefault(import('../pages/bildirimler/index.vue' /* webpackChunkName: "pages/bildirimler/index" */))
const _11399f99 = () => interopDefault(import('../pages/bilpop/index.vue' /* webpackChunkName: "pages/bilpop/index" */))
const _ce2b555c = () => interopDefault(import('../pages/cerez-politikasi/index.vue' /* webpackChunkName: "pages/cerez-politikasi/index" */))
const _5651ac6b = () => interopDefault(import('../pages/kurumsal/index.vue' /* webpackChunkName: "pages/kurumsal/index" */))
const _7567f6ae = () => interopDefault(import('../pages/kurumsal/index/index.vue' /* webpackChunkName: "pages/kurumsal/index/index" */))
const _3b3b3126 = () => interopDefault(import('../pages/kurumsal/index/gizlilik-politikasi.vue' /* webpackChunkName: "pages/kurumsal/index/gizlilik-politikasi" */))
const _6b11f13f = () => interopDefault(import('../pages/kurumsal/index/hakkimizda.vue' /* webpackChunkName: "pages/kurumsal/index/hakkimizda" */))
const _3d0353b4 = () => interopDefault(import('../pages/kurumsal/index/iletisim.vue' /* webpackChunkName: "pages/kurumsal/index/iletisim" */))
const _6a0241d6 = () => interopDefault(import('../pages/kurumsal/index/kariyer.vue' /* webpackChunkName: "pages/kurumsal/index/kariyer" */))
const _8d0f2c5a = () => interopDefault(import('../pages/kurumsal/index/kullanici-sozlesmesi.vue' /* webpackChunkName: "pages/kurumsal/index/kullanici-sozlesmesi" */))
const _b1a6e5a8 = () => interopDefault(import('../pages/kurumsal/index/kunye.vue' /* webpackChunkName: "pages/kurumsal/index/kunye" */))
const _72f44c4a = () => interopDefault(import('../pages/kurumsal/index/topluluk-kurallari.vue' /* webpackChunkName: "pages/kurumsal/index/topluluk-kurallari" */))
const _949d43d0 = () => interopDefault(import('../pages/kurumsal/index/yayin-ilkeleri.vue' /* webpackChunkName: "pages/kurumsal/index/yayin-ilkeleri" */))
const _fb14c2f0 = () => interopDefault(import('../pages/emojile/index.vue' /* webpackChunkName: "pages/emojile/index" */))
const _7a815b09 = () => interopDefault(import('../pages/kesfet/index.vue' /* webpackChunkName: "pages/kesfet/index" */))
const _826bda66 = () => interopDefault(import('../pages/mesaj/index.vue' /* webpackChunkName: "pages/mesaj/index" */))
const _eeebcba0 = () => interopDefault(import('../pages/oyun/index.vue' /* webpackChunkName: "pages/oyun/index" */))
const _fcbd9d0a = () => interopDefault(import('../pages/r/index.vue' /* webpackChunkName: "pages/r/index" */))
const _34850b58 = () => interopDefault(import('../pages/rss.vue' /* webpackChunkName: "pages/rss" */))
const _0a46f700 = () => interopDefault(import('../pages/sanaozel/index.vue' /* webpackChunkName: "pages/sanaozel/index" */))
const _ec63496e = () => interopDefault(import('../pages/trendler/index.vue' /* webpackChunkName: "pages/trendler/index" */))
const _3364af31 = () => interopDefault(import('../pages/tumicerikler/index.vue' /* webpackChunkName: "pages/tumicerikler/index" */))
const _44a00943 = () => interopDefault(import('../pages/vitrin/index.vue' /* webpackChunkName: "pages/vitrin/index" */))
const _1935bda1 = () => interopDefault(import('../pages/yazio/index.vue' /* webpackChunkName: "pages/yazio/index" */))
const _4f2293c2 = () => interopDefault(import('../pages/zekiye/index.vue' /* webpackChunkName: "pages/zekiye/index" */))
const _39dc0820 = () => interopDefault(import('../modules/astrology/pages/CompatibilityResult.vue' /* webpackChunkName: "CompatibilityResult" */))
const _0f75c1a8 = () => interopDefault(import('../pages/astroloji/burc-uyumu-hesaplama/index.vue' /* webpackChunkName: "pages/astroloji/burc-uyumu-hesaplama/index" */))
const _4e0343f0 = () => interopDefault(import('../pages/astroloji/dogum-haritasi-hesaplama/index.vue' /* webpackChunkName: "pages/astroloji/dogum-haritasi-hesaplama/index" */))
const _2a849156 = () => interopDefault(import('../pages/astroloji/_burc/_slug.vue' /* webpackChunkName: "CustomHoroscopeArticle" */))
const _388f3e59 = () => interopDefault(import('../pages/astroloji/yukselen-burc-hesaplama/index.vue' /* webpackChunkName: "pages/astroloji/yukselen-burc-hesaplama/index" */))
const _bc625412 = () => interopDefault(import('../pages/ayarlar/engellenen-hesaplar.vue' /* webpackChunkName: "pages/ayarlar/engellenen-hesaplar" */))
const _f3fac482 = () => interopDefault(import('../pages/ayarlar/hesap-dondurma.vue' /* webpackChunkName: "pages/ayarlar/hesap-dondurma" */))
const _d2f0c71e = () => interopDefault(import('../pages/ayarlar/hesap-silme.vue' /* webpackChunkName: "pages/ayarlar/hesap-silme" */))
const _041c4ebc = () => interopDefault(import('../pages/ayarlar/sifre-degistir.vue' /* webpackChunkName: "pages/ayarlar/sifre-degistir" */))
const _9d410026 = () => interopDefault(import('../pages/aydinlatma-metni/calisan-adayi.vue' /* webpackChunkName: "pages/aydinlatma-metni/calisan-adayi" */))
const _3fb3d99c = () => interopDefault(import('../pages/aydinlatma-metni/fiziki-ziyaretci.vue' /* webpackChunkName: "pages/aydinlatma-metni/fiziki-ziyaretci" */))
const _1445949a = () => interopDefault(import('../pages/aydinlatma-metni/ilgili-kisi-basvuru-formu.vue' /* webpackChunkName: "pages/aydinlatma-metni/ilgili-kisi-basvuru-formu" */))
const _3019357b = () => interopDefault(import('../pages/aydinlatma-metni/musteri-adayi.vue' /* webpackChunkName: "pages/aydinlatma-metni/musteri-adayi" */))
const _2447d5ea = () => interopDefault(import('../pages/aydinlatma-metni/uye-ziyaretci.vue' /* webpackChunkName: "pages/aydinlatma-metni/uye-ziyaretci" */))
const _2249dd08 = () => interopDefault(import('../pages/dev/counter.vue' /* webpackChunkName: "pages/dev/counter" */))
const _27dd0703 = () => interopDefault(import('../pages/dev/reco.vue' /* webpackChunkName: "pages/dev/reco" */))
const _40a5bbca = () => interopDefault(import('../pages/haber/yarat.vue' /* webpackChunkName: "pages/haber/yarat" */))
const _26c0b582 = () => interopDefault(import('../pages/mobile/bilpop.vue' /* webpackChunkName: "pages/mobile/bilpop" */))
const _435cb13c = () => interopDefault(import('../pages/mobile/emojile.vue' /* webpackChunkName: "pages/mobile/emojile" */))
const _36afcdd6 = () => interopDefault(import('../pages/astroloji/dogum-haritasi-hesaplama/sonuc.vue' /* webpackChunkName: "pages/astroloji/dogum-haritasi-hesaplama/sonuc" */))
const _09696e1c = () => interopDefault(import('../pages/astroloji/tarot/tarot-kartlari-ve-anlamlari.vue' /* webpackChunkName: "TarotMinorArcanaCards" */))
const _3f75d9e5 = () => interopDefault(import('../modules/tarot/pages/meaningPage.vue' /* webpackChunkName: "TarotCardsMeaning" */))
const _d37ea3b2 = () => interopDefault(import('../pages/astroloji/yukselen-burc-hesaplama/sonuc.vue' /* webpackChunkName: "pages/astroloji/yukselen-burc-hesaplama/sonuc" */))
const _89c8af24 = () => interopDefault(import('../pages/auth/twitter/callback.vue' /* webpackChunkName: "pages/auth/twitter/callback" */))
const _466469dc = () => interopDefault(import('../pages/embed/widget/leaderboard.vue' /* webpackChunkName: "pages/embed/widget/leaderboard" */))
const _547b82d2 = () => interopDefault(import('../modules/category/pages/categoryPage.vue' /* webpackChunkName: "CategoryPage" */))
const _304bc57f = () => interopDefault(import('../pages/mobile/oyun/leaderboard/_slug.vue' /* webpackChunkName: "pages/mobile/oyun/leaderboard/_slug" */))
const _6ddd5cbf = () => interopDefault(import('../pages/mobile/oyun/skor/_slug.vue' /* webpackChunkName: "pages/mobile/oyun/skor/_slug" */))
const _db0c8cf8 = () => interopDefault(import('../pages/ara/etiket/_slug.vue' /* webpackChunkName: "pages/ara/etiket/_slug" */))
const _c08fb810 = () => interopDefault(import('../pages/ara/haber/_slug.vue' /* webpackChunkName: "pages/ara/haber/_slug" */))
const _3ffd4743 = () => interopDefault(import('../pages/ara/uye/_slug.vue' /* webpackChunkName: "pages/ara/uye/_slug" */))
const _3db57f00 = () => interopDefault(import('../pages/astroloji/tarot/_slug/index.vue' /* webpackChunkName: "pages/astroloji/tarot/_slug/index" */))
const _21f42f93 = () => interopDefault(import('../pages/auth/delete-account/_slug.vue' /* webpackChunkName: "pages/auth/delete-account/_slug" */))
const _b0f27e7a = () => interopDefault(import('../pages/auth/forgot-password/_slug.vue' /* webpackChunkName: "pages/auth/forgot-password/_slug" */))
const _0bc6f761 = () => interopDefault(import('../pages/auth/reset-password/_slug.vue' /* webpackChunkName: "pages/auth/reset-password/_slug" */))
const _b7529c60 = () => interopDefault(import('../pages/auth/verify-email/_slug.vue' /* webpackChunkName: "pages/auth/verify-email/_slug" */))
const _0611b3d6 = () => interopDefault(import('../pages/oyun/leaderboard/_slug.vue' /* webpackChunkName: "pages/oyun/leaderboard/_slug" */))
const _c30a5b70 = () => interopDefault(import('../pages/oyun/skor/_slug.vue' /* webpackChunkName: "pages/oyun/skor/_slug" */))
const _72beb39d = () => interopDefault(import('../pages/astroloji/tarot/_slug/_card.vue' /* webpackChunkName: "pages/astroloji/tarot/_slug/_card" */))
const _3c773672 = () => interopDefault(import('../modules/tag/pages/TagPage.vue' /* webpackChunkName: "TagPage" */))
const _a4a8570e = () => interopDefault(import('../pages/akis/_slug.vue' /* webpackChunkName: "pages/akis/_slug" */))
const _80a200a4 = () => interopDefault(import('../pages/amp-haber/_slug.vue' /* webpackChunkName: "pages/amp-haber/_slug" */))
const _67dd2dde = () => interopDefault(import('../pages/ara/_slug.vue' /* webpackChunkName: "pages/ara/_slug" */))
const _01c33a28 = () => interopDefault(import('../modules/customPages/pages/customCategoryPage.vue' /* webpackChunkName: "customCategoryPage" */))
const _a208d6ae = () => interopDefault(import('../pages/h/_slug.vue' /* webpackChunkName: "pages/h/_slug" */))
const _638bf4b7 = () => interopDefault(import('../pages/haber/_slug.vue' /* webpackChunkName: "pages/haber/_slug" */))
const _2a2b3973 = () => interopDefault(import('../pages/instagram/_slug.vue' /* webpackChunkName: "pages/instagram/_slug" */))
const _f2590e30 = () => interopDefault(import('../pages/oyun/_slug.vue' /* webpackChunkName: "pages/oyun/_slug" */))
const _6264ec8f = () => interopDefault(import('../pages/profil/_username/index.vue' /* webpackChunkName: "pages/profil/_username/index" */))
const _0f3c3a60 = () => interopDefault(import('../pages/profil/_username/index/icerikler.vue' /* webpackChunkName: "pages/profil/_username/index/icerikler" */))
const _eb22c564 = () => interopDefault(import('../pages/profil/_username/index/favoriler.vue' /* webpackChunkName: "pages/profil/_username/index/favoriler" */))
const _5b304122 = () => interopDefault(import('../pages/profil/_username/index/takip-ettikleri.vue' /* webpackChunkName: "pages/profil/_username/index/takip-ettikleri" */))
const _1170ecfe = () => interopDefault(import('../pages/profil/_username/index/takipciler.vue' /* webpackChunkName: "pages/profil/_username/index/takipciler" */))
const _228c5d19 = () => interopDefault(import('../pages/profil/_username/index/yorumlar.vue' /* webpackChunkName: "pages/profil/_username/index/yorumlar" */))
const _1087887c = () => interopDefault(import('../pages/uye/_slug.vue' /* webpackChunkName: "pages/uye/_slug" */))
const _177f1c59 = () => interopDefault(import('../pages/yazio/_slug.vue' /* webpackChunkName: "pages/yazio/_slug" */))
const _5778039d = () => interopDefault(import('../pages/mobile/_slug/view.vue' /* webpackChunkName: "pages/mobile/_slug/view" */))
const _cb375fde = () => interopDefault(import('../pages/profil/_username/ayarlar.vue' /* webpackChunkName: "pages/profil/_username/ayarlar" */))
const _3e48db2a = () => interopDefault(import('../pages/mesaj/_username/_slug.vue' /* webpackChunkName: "pages/mesaj/_username/_slug" */))
const _16ef6b7c = () => interopDefault(import('../pages/vitrin/_slug/_pageNum.vue' /* webpackChunkName: "pages/vitrin/_slug/_pageNum" */))
const _5c8fd7fd = () => interopDefault(import('../pages/etiket/_tagName/_tagId/_pageNum.vue' /* webpackChunkName: "pages/etiket/_tagName/_tagId/_pageNum" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/23-nisan",
    component: _463c6b1f
  }, {
    path: "/23-nisan-galeri",
    component: _463c6b1f
  }, {
    path: "/29-ekim-cumhuriyet-bayrami-2024",
    component: _463c6b1f
  }, {
    path: "/6284-hayatlari-degistirir",
    component: _463c6b1f
  }, {
    path: "/akbank-caz-festivali",
    component: _463c6b1f
  }, {
    path: "/akbank-kisafilmfestivali",
    component: _463c6b1f
  }, {
    path: "/akbank-surdurebilirlik",
    component: _463c6b1f
  }, {
    path: "/akbank-yilbasi24",
    component: _463c6b1f
  }, {
    path: "/akbank29ekim",
    component: _463c6b1f
  }, {
    path: "/akbankcazfestivali",
    component: _463c6b1f
  }, {
    path: "/ara",
    component: _646feb4e,
    name: "ara___tr"
  }, {
    path: "/ayarlar",
    component: _03d1d2c6,
    name: "ayarlar___tr"
  }, {
    path: "/bigbet",
    component: _463c6b1f
  }, {
    path: "/bildirimler",
    component: _2f01bfd6,
    name: "bildirimler___tr"
  }, {
    path: "/bilpop",
    component: _11399f99,
    name: "bilpop___tr"
  }, {
    path: "/cerez-politikasi",
    component: _ce2b555c,
    name: "cerez-politikasi___tr"
  }, {
    path: "/converse-ourbeat",
    component: _463c6b1f
  }, {
    path: "/corporate",
    component: _5651ac6b,
    children: [{
      path: "",
      component: _7567f6ae,
      name: "kurumsal-index___tr"
    }, {
      path: "/kurumsal/gizlilik-politikasi",
      component: _3b3b3126,
      name: "kurumsal-index-gizlilik-politikasi___tr"
    }, {
      path: "/kurumsal/hakkimizda",
      component: _6b11f13f,
      name: "kurumsal-index-hakkimizda___tr"
    }, {
      path: "/kurumsal/iletisim",
      component: _3d0353b4,
      name: "kurumsal-index-iletisim___tr"
    }, {
      path: "/kurumsal/kariyer",
      component: _6a0241d6,
      name: "kurumsal-index-kariyer___tr"
    }, {
      path: "/kurumsal/kullanici-sozlesmesi",
      component: _8d0f2c5a,
      name: "kurumsal-index-kullanici-sozlesmesi___tr"
    }, {
      path: "/kurumsal/kunye",
      component: _b1a6e5a8,
      name: "kurumsal-index-kunye___tr"
    }, {
      path: "/kurumsal/topluluk-kurallari",
      component: _72f44c4a,
      name: "kurumsal-index-topluluk-kurallari___tr"
    }, {
      path: "/kurumsal/yayin-ilkeleri",
      component: _949d43d0,
      name: "kurumsal-index-yayin-ilkeleri___tr"
    }]
  }, {
    path: "/emojile",
    component: _fb14c2f0,
    name: "emojile___tr"
  }, {
    path: "/evyapilebakim",
    component: _463c6b1f
  }, {
    path: "/ford-trucks-takim-arkadasi",
    component: _463c6b1f
  }, {
    path: "/heykel-ai",
    component: _463c6b1f
  }, {
    path: "/isbankasi-kk",
    component: _463c6b1f
  }, {
    path: "/kesfet",
    component: _7a815b09,
    name: "kesfet___tr"
  }, {
    path: "/lenovo-aura",
    component: _463c6b1f
  }, {
    path: "/mesaj",
    component: _826bda66,
    name: "mesaj___tr"
  }, {
    path: "/onedio-sunum",
    component: _463c6b1f
  }, {
    path: "/oyun",
    component: _eeebcba0,
    name: "oyun___tr"
  }, {
    path: "/r",
    component: _fcbd9d0a,
    name: "r___tr"
  }, {
    path: "/rss",
    component: _34850b58,
    name: "rss___tr"
  }, {
    path: "/sanaozel",
    component: _0a46f700,
    name: "sanaozel___tr"
  }, {
    path: "/seninmakyajin",
    component: _463c6b1f
  }, {
    path: "/tib-olimpiyat",
    component: _463c6b1f
  }, {
    path: "/tib-ramazan",
    component: _463c6b1f
  }, {
    path: "/tib-ramazan-25",
    component: _463c6b1f
  }, {
    path: "/tibbugenclikbenim",
    component: _463c6b1f
  }, {
    path: "/trendler",
    component: _ec63496e,
    name: "trendler___tr"
  }, {
    path: "/tumicerikler",
    component: _3364af31,
    name: "tumicerikler___tr"
  }, {
    path: "/ulker-mini",
    component: _463c6b1f
  }, {
    path: "/vitrin",
    component: _44a00943,
    name: "vitrin___tr"
  }, {
    path: "/yazio",
    component: _1935bda1,
    name: "yazio___tr"
  }, {
    path: "/zekiye",
    component: _4f2293c2,
    name: "zekiye___tr"
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/*-burc-uyumu",
    component: _39dc0820
  }, {
    path: "/astroloji/burc-uyumu-hesaplama",
    component: _0f75c1a8,
    name: "astroloji-burc-uyumu-hesaplama___tr"
  }, {
    path: "/astroloji/dogum-haritasi-hesaplama",
    component: _4e0343f0,
    name: "astroloji-dogum-haritasi-hesaplama___tr"
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/gunluk*-burc-yorumuna-gore-*",
    component: _2a849156
  }, {
    path: "/astroloji/yukselen-burc-hesaplama",
    component: _388f3e59,
    name: "astroloji-yukselen-burc-hesaplama___tr"
  }, {
    path: "/ayarlar/engellenen-hesaplar",
    component: _bc625412,
    name: "ayarlar-engellenen-hesaplar___tr"
  }, {
    path: "/ayarlar/hesap-dondurma",
    component: _f3fac482,
    name: "ayarlar-hesap-dondurma___tr"
  }, {
    path: "/ayarlar/hesap-silme",
    component: _d2f0c71e,
    name: "ayarlar-hesap-silme___tr"
  }, {
    path: "/ayarlar/sifre-degistir",
    component: _041c4ebc,
    name: "ayarlar-sifre-degistir___tr"
  }, {
    path: "/aydinlatma-metni/calisan-adayi",
    component: _9d410026,
    name: "aydinlatma-metni-calisan-adayi___tr"
  }, {
    path: "/aydinlatma-metni/fiziki-ziyaretci",
    component: _3fb3d99c,
    name: "aydinlatma-metni-fiziki-ziyaretci___tr"
  }, {
    path: "/aydinlatma-metni/ilgili-kisi-basvuru-formu",
    component: _1445949a,
    name: "aydinlatma-metni-ilgili-kisi-basvuru-formu___tr"
  }, {
    path: "/aydinlatma-metni/musteri-adayi",
    component: _3019357b,
    name: "aydinlatma-metni-musteri-adayi___tr"
  }, {
    path: "/aydinlatma-metni/uye-ziyaretci",
    component: _2447d5ea,
    name: "aydinlatma-metni-uye-ziyaretci___tr"
  }, {
    path: "/dev/counter",
    component: _2249dd08,
    name: "dev-counter___tr"
  }, {
    path: "/dev/reco",
    component: _27dd0703,
    name: "dev-reco___tr"
  }, {
    path: "/haber/yarat",
    component: _40a5bbca,
    name: "haber-yarat___tr"
  }, {
    path: "/mobile/bilpop",
    component: _26c0b582,
    name: "mobile-bilpop___tr"
  }, {
    path: "/mobile/emojile",
    component: _435cb13c,
    name: "mobile-emojile___tr"
  }, {
    path: "/astroloji/dogum-haritasi-hesaplama/sonuc",
    component: _36afcdd6,
    name: "astroloji-dogum-haritasi-hesaplama-sonuc___tr"
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-minor-arcana-kartlari",
    component: _09696e1c
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/*-tarot-karti-anlami",
    component: _3f75d9e5
  }, {
    path: "/astroloji/tarot/tarot-kartlari-ve-anlamlari",
    component: _09696e1c,
    name: "astroloji-tarot-tarot-kartlari-ve-anlamlari___tr"
  }, {
    path: "/astroloji/yukselen-burc-hesaplama/sonuc",
    component: _d37ea3b2,
    name: "astroloji-yukselen-burc-hesaplama-sonuc___tr"
  }, {
    path: "/auth/twitter/callback",
    component: _89c8af24,
    name: "auth-twitter-callback___tr"
  }, {
    path: "/embed/widget/leaderboard",
    component: _466469dc,
    name: "embed-widget-leaderboard___tr"
  }, {
    path: "/egitim/yks/ayt/:subOrPagination?",
    component: _547b82d2,
    name: "/egitim/yks/ayt___tr"
  }, {
    path: "/egitim/yks/tyt/:subOrPagination?",
    component: _547b82d2,
    name: "/egitim/yks/tyt___tr"
  }, {
    path: "/egitim/yks/ydt/:subOrPagination?",
    component: _547b82d2,
    name: "/egitim/yks/ydt___tr"
  }, {
    path: "/ekonomi/altin-fiyatlari/ceyrek-altin/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/altin-fiyatlari/ceyrek-altin___tr"
  }, {
    path: "/ekonomi/altin-fiyatlari/cumhuriyet-altini/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/altin-fiyatlari/cumhuriyet-altini___tr"
  }, {
    path: "/ekonomi/altin-fiyatlari/gram-altin/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/altin-fiyatlari/gram-altin___tr"
  }, {
    path: "/ekonomi/altin-fiyatlari/ons-altin/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/altin-fiyatlari/ons-altin___tr"
  }, {
    path: "/ekonomi/altin-fiyatlari/tam-altin/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/altin-fiyatlari/tam-altin___tr"
  }, {
    path: "/ekonomi/altin-fiyatlari/yarim-altin/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/altin-fiyatlari/yarim-altin___tr"
  }, {
    path: "/ekonomi/doviz/dolar/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/doviz/dolar___tr"
  }, {
    path: "/ekonomi/doviz/euro/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/doviz/euro___tr"
  }, {
    path: "/ekonomi/doviz/sterlin/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/doviz/sterlin___tr"
  }, {
    path: "/ekonomi/kripto-para/bitcoin/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/kripto-para/bitcoin___tr"
  }, {
    path: "/mobile/oyun/leaderboard/:slug?",
    component: _304bc57f,
    name: "mobile-oyun-leaderboard-slug___tr"
  }, {
    path: "/mobile/oyun/skor/:slug?",
    component: _6ddd5cbf,
    name: "mobile-oyun-skor-slug___tr"
  }, {
    path: "/spor/futbol/besiktas/:subOrPagination?",
    component: _547b82d2,
    name: "/spor/futbol/besiktas___tr"
  }, {
    path: "/spor/futbol/fenerbahce/:subOrPagination?",
    component: _547b82d2,
    name: "/spor/futbol/fenerbahce___tr"
  }, {
    path: "/spor/futbol/galatasaray/:subOrPagination?",
    component: _547b82d2,
    name: "/spor/futbol/galatasaray___tr"
  }, {
    path: "/spor/futbol/trabzonspor/:subOrPagination?",
    component: _547b82d2,
    name: "/spor/futbol/trabzonspor___tr"
  }, {
    path: "/yasam/astroloji/akrep-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/akrep-burcu___tr"
  }, {
    path: "/yasam/astroloji/aslan-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/aslan-burcu___tr"
  }, {
    path: "/yasam/astroloji/balik-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/balik-burcu___tr"
  }, {
    path: "/yasam/astroloji/basak-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/basak-burcu___tr"
  }, {
    path: "/yasam/astroloji/boga-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/boga-burcu___tr"
  }, {
    path: "/yasam/astroloji/dogum-haritasi/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/dogum-haritasi___tr"
  }, {
    path: "/yasam/astroloji/ikizler-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/ikizler-burcu___tr"
  }, {
    path: "/yasam/astroloji/koc-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/koc-burcu___tr"
  }, {
    path: "/yasam/astroloji/kova-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/kova-burcu___tr"
  }, {
    path: "/yasam/astroloji/oglak-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/oglak-burcu___tr"
  }, {
    path: "/yasam/astroloji/tarot-fali/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/tarot-fali___tr"
  }, {
    path: "/yasam/astroloji/terazi-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/terazi-burcu___tr"
  }, {
    path: "/yasam/astroloji/yay-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/yay-burcu___tr"
  }, {
    path: "/yasam/astroloji/yengec-burcu/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji/yengec-burcu___tr"
  }, {
    path: "/yasam/guzellik/cilt-vucut-bakimi/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/guzellik/cilt-vucut-bakimi___tr"
  }, {
    path: "/yasam/guzellik/estetik/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/guzellik/estetik___tr"
  }, {
    path: "/yasam/guzellik/makyaj/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/guzellik/makyaj___tr"
  }, {
    path: "/yasam/guzellik/sac-bakimi/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/guzellik/sac-bakimi___tr"
  }, {
    path: "/yasam/hayvanlar/kedi/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/hayvanlar/kedi___tr"
  }, {
    path: "/yasam/hayvanlar/kopek/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/hayvanlar/kopek___tr"
  }, {
    path: "/yasam/hayvanlar/kus/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/hayvanlar/kus___tr"
  }, {
    path: "/yasam/iliskiler/ask/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/iliskiler/ask___tr"
  }, {
    path: "/yasam/iliskiler/cinsellik/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/iliskiler/cinsellik___tr"
  }, {
    path: "/yasam/iliskiler/evlilik/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/iliskiler/evlilik___tr"
  }, {
    path: "/yemek/hamur-isi/borek/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/hamur-isi/borek___tr"
  }, {
    path: "/yemek/hamur-isi/ekmek/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/hamur-isi/ekmek___tr"
  }, {
    path: "/yemek/hamur-isi/hamburger/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/hamur-isi/hamburger___tr"
  }, {
    path: "/yemek/hamur-isi/kurabiye/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/hamur-isi/kurabiye___tr"
  }, {
    path: "/yemek/hamur-isi/pizza/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/hamur-isi/pizza___tr"
  }, {
    path: "/yemek/hamur-isi/pogaca/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/hamur-isi/pogaca___tr"
  }, {
    path: "/yemek/tatli/cikolatali-tatlilar/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/tatli/cikolatali-tatlilar___tr"
  }, {
    path: "/yemek/tatli/pasta-kek/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/tatli/pasta-kek___tr"
  }, {
    path: "/yemek/tatli/serbetli-tatlilar/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/tatli/serbetli-tatlilar___tr"
  }, {
    path: "/yemek/tatli/sutlu-tatlilar/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/tatli/sutlu-tatlilar___tr"
  }, {
    path: "/yemek/tatli/yoresel-tatlilar/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/tatli/yoresel-tatlilar___tr"
  }, {
    path: "/ara/etiket/:slug?",
    component: _db0c8cf8,
    name: "ara-etiket-slug___tr"
  }, {
    path: "/ara/haber/:slug?",
    component: _c08fb810,
    name: "ara-haber-slug___tr"
  }, {
    path: "/ara/uye/:slug?",
    component: _3ffd4743,
    name: "ara-uye-slug___tr"
  }, {
    path: "/astroloji/tarot/:slug",
    component: _3db57f00,
    name: "astroloji-tarot-slug___tr"
  }, {
    path: "/auth/delete-account/:slug?",
    component: _21f42f93,
    name: "auth-delete-account-slug___tr"
  }, {
    path: "/auth/forgot-password/:slug?",
    component: _b0f27e7a,
    name: "auth-forgot-password-slug___tr"
  }, {
    path: "/auth/reset-password/:slug?",
    component: _0bc6f761,
    name: "auth-reset-password-slug___tr"
  }, {
    path: "/auth/verify-email/:slug?",
    component: _b7529c60,
    name: "auth-verify-email-slug___tr"
  }, {
    path: "/blog/inanc/:subOrPagination?",
    component: _547b82d2,
    name: "/blog/inanc___tr"
  }, {
    path: "/blog/sozler-ve-mesajlar/:subOrPagination?",
    component: _547b82d2,
    name: "/blog/sozler-ve-mesajlar___tr"
  }, {
    path: "/egitim/ales/:subOrPagination?",
    component: _547b82d2,
    name: "/egitim/ales___tr"
  }, {
    path: "/egitim/dgs/:subOrPagination?",
    component: _547b82d2,
    name: "/egitim/dgs___tr"
  }, {
    path: "/egitim/kpss/:subOrPagination?",
    component: _547b82d2,
    name: "/egitim/kpss___tr"
  }, {
    path: "/egitim/lgs/:subOrPagination?",
    component: _547b82d2,
    name: "/egitim/lgs___tr"
  }, {
    path: "/egitim/yks/:subOrPagination?",
    component: _547b82d2,
    name: "/egitim/yks___tr"
  }, {
    path: "/ekonomi/altin-fiyatlari/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/altin-fiyatlari___tr"
  }, {
    path: "/ekonomi/borsa/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/borsa___tr"
  }, {
    path: "/ekonomi/doviz/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/doviz___tr"
  }, {
    path: "/ekonomi/girisimcilik/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/girisimcilik___tr"
  }, {
    path: "/ekonomi/kredi/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/kredi___tr"
  }, {
    path: "/ekonomi/kripto-para/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/kripto-para___tr"
  }, {
    path: "/ekonomi/sigorta/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi/sigorta___tr"
  }, {
    path: "/gaming/esport/:subOrPagination?",
    component: _547b82d2,
    name: "/gaming/esport___tr"
  }, {
    path: "/gaming/konsol/:subOrPagination?",
    component: _547b82d2,
    name: "/gaming/konsol___tr"
  }, {
    path: "/gaming/mobil/:subOrPagination?",
    component: _547b82d2,
    name: "/gaming/mobil___tr"
  }, {
    path: "/gaming/pc/:subOrPagination?",
    component: _547b82d2,
    name: "/gaming/pc___tr"
  }, {
    path: "/genel-kultur/bilim/:subOrPagination?",
    component: _547b82d2,
    name: "/genel-kultur/bilim___tr"
  }, {
    path: "/genel-kultur/kitap/:subOrPagination?",
    component: _547b82d2,
    name: "/genel-kultur/kitap___tr"
  }, {
    path: "/genel-kultur/muzik/:subOrPagination?",
    component: _547b82d2,
    name: "/genel-kultur/muzik___tr"
  }, {
    path: "/genel-kultur/sanat/:subOrPagination?",
    component: _547b82d2,
    name: "/genel-kultur/sanat___tr"
  }, {
    path: "/genel-kultur/tarih/:subOrPagination?",
    component: _547b82d2,
    name: "/genel-kultur/tarih___tr"
  }, {
    path: "/gundem/son-dakika/:subOrPagination?",
    component: _547b82d2,
    name: "/gundem/son-dakika___tr"
  }, {
    path: "/magazin/unluler-dosyasi/:subOrPagination?",
    component: _547b82d2,
    name: "/magazin/unluler-dosyasi___tr"
  }, {
    path: "/oyun/leaderboard/:slug?",
    component: _0611b3d6,
    name: "oyun-leaderboard-slug___tr"
  }, {
    path: "/oyun/skor/:slug?",
    component: _c30a5b70,
    name: "oyun-skor-slug___tr"
  }, {
    path: "/saglik/alternatif-tip/:subOrPagination?",
    component: _547b82d2,
    name: "/saglik/alternatif-tip___tr"
  }, {
    path: "/saglik/cinsel-saglik-ve-yasam/:subOrPagination?",
    component: _547b82d2,
    name: "/saglik/cinsel-saglik-ve-yasam___tr"
  }, {
    path: "/saglik/covid-19/:subOrPagination?",
    component: _547b82d2,
    name: "/saglik/covid-19___tr"
  }, {
    path: "/saglik/hastaliklar/:subOrPagination?",
    component: _547b82d2,
    name: "/saglik/hastaliklar___tr"
  }, {
    path: "/saglik/psikoloji/:subOrPagination?",
    component: _547b82d2,
    name: "/saglik/psikoloji___tr"
  }, {
    path: "/spor/basketbol/:subOrPagination?",
    component: _547b82d2,
    name: "/spor/basketbol___tr"
  }, {
    path: "/spor/e-spor/:subOrPagination?",
    component: _547b82d2,
    name: "/spor/e-spor___tr"
  }, {
    path: "/spor/formula-1/:subOrPagination?",
    component: _547b82d2,
    name: "/spor/formula-1___tr"
  }, {
    path: "/spor/futbol/:subOrPagination?",
    component: _547b82d2,
    name: "/spor/futbol___tr"
  }, {
    path: "/spor/voleybol/:subOrPagination?",
    component: _547b82d2,
    name: "/spor/voleybol___tr"
  }, {
    path: "/teknoloji/donanim-yazilim/:subOrPagination?",
    component: _547b82d2,
    name: "/teknoloji/donanim-yazilim___tr"
  }, {
    path: "/teknoloji/urun-incelemeleri/:subOrPagination?",
    component: _547b82d2,
    name: "/teknoloji/urun-incelemeleri___tr"
  }, {
    path: "/teknoloji/yapay-zeka/:subOrPagination?",
    component: _547b82d2,
    name: "/teknoloji/yapay-zeka___tr"
  }, {
    path: "/test/anket/:subOrPagination?",
    component: _547b82d2,
    name: "/test/anket___tr"
  }, {
    path: "/test/astroloji-testleri/:subOrPagination?",
    component: _547b82d2,
    name: "/test/astroloji-testleri___tr"
  }, {
    path: "/test/genel-kultur-testleri/:subOrPagination?",
    component: _547b82d2,
    name: "/test/genel-kultur-testleri___tr"
  }, {
    path: "/test/iliski-testleri/:subOrPagination?",
    component: _547b82d2,
    name: "/test/iliski-testleri___tr"
  }, {
    path: "/test/kisilik-testleri/:subOrPagination?",
    component: _547b82d2,
    name: "/test/kisilik-testleri___tr"
  }, {
    path: "/test/psikoloji-testleri/:subOrPagination?",
    component: _547b82d2,
    name: "/test/psikoloji-testleri___tr"
  }, {
    path: "/test/yemek-testleri/:subOrPagination?",
    component: _547b82d2,
    name: "/test/yemek-testleri___tr"
  }, {
    path: "/yasam/anne-bebek/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/anne-bebek___tr"
  }, {
    path: "/yasam/astroloji/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/astroloji___tr"
  }, {
    path: "/yasam/biyografi/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/biyografi___tr"
  }, {
    path: "/yasam/dekorasyon/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/dekorasyon___tr"
  }, {
    path: "/yasam/guzellik/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/guzellik___tr"
  }, {
    path: "/yasam/hayvanlar/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/hayvanlar___tr"
  }, {
    path: "/yasam/iliskiler/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/iliskiler___tr"
  }, {
    path: "/yasam/moda/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/moda___tr"
  }, {
    path: "/yasam/otomobil/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/otomobil___tr"
  }, {
    path: "/yasam/puf-noktasi/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/puf-noktasi___tr"
  }, {
    path: "/yasam/ruya-tabirleri/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/ruya-tabirleri___tr"
  }, {
    path: "/yasam/temizlik/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam/temizlik___tr"
  }, {
    path: "/yemek/atistirmalik/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/atistirmalik___tr"
  }, {
    path: "/yemek/corba/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/corba___tr"
  }, {
    path: "/yemek/diyet/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/diyet___tr"
  }, {
    path: "/yemek/et-tavuk-deniz/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/et-tavuk-deniz___tr"
  }, {
    path: "/yemek/glutensiz/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/glutensiz___tr"
  }, {
    path: "/yemek/hamur-isi/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/hamur-isi___tr"
  }, {
    path: "/yemek/icecek-tarifleri/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/icecek-tarifleri___tr"
  }, {
    path: "/yemek/kahvaltilik/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/kahvaltilik___tr"
  }, {
    path: "/yemek/makarna/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/makarna___tr"
  }, {
    path: "/yemek/meze/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/meze___tr"
  }, {
    path: "/yemek/pratik-tarifler/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/pratik-tarifler___tr"
  }, {
    path: "/yemek/pratik-yemekler/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/pratik-yemekler___tr"
  }, {
    path: "/yemek/salata/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/salata___tr"
  }, {
    path: "/yemek/sulu-yemek/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/sulu-yemek___tr"
  }, {
    path: "/yemek/tatli/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/tatli___tr"
  }, {
    path: "/yemek/vegan/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/vegan___tr"
  }, {
    path: "/yemek/video-tarifler/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/video-tarifler___tr"
  }, {
    path: "/yemek/yedikce-ogren/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek/yedikce-ogren___tr"
  }, {
    path: "/astroloji/tarot/:slug?/:card",
    component: _72beb39d,
    name: "astroloji-tarot-slug-card___tr"
  }, {
    path: "/*-haberleri/:pageNum?",
    component: _3c773672
  }, {
    path: "/akis/:slug?",
    component: _a4a8570e,
    name: "akis-slug___tr"
  }, {
    path: "/amp-haber/:slug?",
    component: _80a200a4,
    name: "amp-haber-slug___tr"
  }, {
    path: "/ara/:slug?",
    component: _67dd2dde,
    name: "ara-slug___tr"
  }, {
    path: "/blog/:subOrPagination?",
    component: _547b82d2,
    name: "/blog___tr"
  }, {
    path: "/dizi-film/:subOrPagination?",
    component: _547b82d2,
    name: "/dizi-film___tr"
  }, {
    path: "/egitim/:subOrPagination?",
    component: _547b82d2,
    name: "/egitim___tr"
  }, {
    path: "/ekonomi/:subOrPagination?",
    component: _547b82d2,
    name: "/ekonomi___tr"
  }, {
    path: "/ekran/:subOrPagination?",
    component: _547b82d2,
    name: "/ekran___tr"
  }, {
    path: "/finans/:subOrPagination?",
    component: _547b82d2,
    name: "/finans___tr"
  }, {
    path: "/galeriler/:pageNum?",
    component: _01c33a28,
    meta: {"name":"Galeriler","withAds":true,"editorial":true,"api":"gallery","title":"Galeriler","description":"En İyi, En Güncel, En Çok Konuşulan Galeriler Onedio'da."},
    name: "galeriler___tr"
  }, {
    path: "/gaming/:subOrPagination?",
    component: _547b82d2,
    name: "/gaming___tr"
  }, {
    path: "/genel-kultur/:subOrPagination?",
    component: _547b82d2,
    name: "/genel-kultur___tr"
  }, {
    path: "/giybet/:subOrPagination?",
    component: _547b82d2,
    name: "/giybet___tr"
  }, {
    path: "/goygoy/:subOrPagination?",
    component: _547b82d2,
    name: "/goygoy___tr"
  }, {
    path: "/guncel/:subOrPagination?",
    component: _547b82d2,
    name: "/guncel___tr"
  }, {
    path: "/gundem/:subOrPagination?",
    component: _547b82d2,
    name: "/gundem___tr"
  }, {
    path: "/h/:slug?",
    component: _a208d6ae,
    name: "h-slug___tr"
  }, {
    path: "/haber/:slug?",
    component: _638bf4b7,
    name: "haber-slug___tr"
  }, {
    path: "/instagram/:slug?",
    component: _2a2b3973,
    name: "instagram-slug___tr"
  }, {
    path: "/magazin/:subOrPagination?",
    component: _547b82d2,
    name: "/magazin___tr"
  }, {
    path: "/nasil-yapilir/:subOrPagination?",
    component: _547b82d2,
    name: "/nasil-yapilir___tr"
  }, {
    path: "/onedio-ozel/:subOrPagination?",
    component: _547b82d2,
    name: "/onedio-ozel___tr"
  }, {
    path: "/oyun/:slug?",
    component: _f2590e30,
    name: "oyun-slug___tr"
  }, {
    path: "/profil/:username",
    component: _6264ec8f,
    name: "profil-username___tr",
    children: [{
      path: "icerikler",
      component: _0f3c3a60,
      name: "profil-username-index-icerikler___tr"
    }, {
      path: "/profil/:username/favoriler",
      component: _eb22c564,
      name: "profil-username-index-favoriler___tr"
    }, {
      path: "/profil/:username/takip-ettikleri",
      component: _5b304122,
      name: "profil-username-index-takip-ettikleri___tr"
    }, {
      path: "/profil/:username/takipciler",
      component: _1170ecfe,
      name: "profil-username-index-takipciler___tr"
    }, {
      path: "/profil/:username/yorumlar",
      component: _228c5d19,
      name: "profil-username-index-yorumlar___tr"
    }]
  }, {
    path: "/saglik/:subOrPagination?",
    component: _547b82d2,
    name: "/saglik___tr"
  }, {
    path: "/seyahat/:subOrPagination?",
    component: _547b82d2,
    name: "/seyahat___tr"
  }, {
    path: "/spor/:subOrPagination?",
    component: _547b82d2,
    name: "/spor___tr"
  }, {
    path: "/teknoloji/:subOrPagination?",
    component: _547b82d2,
    name: "/teknoloji___tr"
  }, {
    path: "/test/:subOrPagination?",
    component: _547b82d2,
    name: "/test___tr"
  }, {
    path: "/tv/:subOrPagination?",
    component: _547b82d2,
    name: "/tv___tr"
  }, {
    path: "/uye/:slug?",
    component: _1087887c,
    name: "uye-slug___tr"
  }, {
    path: "/video/:subOrPagination?",
    component: _547b82d2,
    name: "/video___tr"
  }, {
    path: "/yasam/:subOrPagination?",
    component: _547b82d2,
    name: "/yasam___tr"
  }, {
    path: "/yazio/:slug",
    component: _177f1c59,
    name: "yazio-slug___tr"
  }, {
    path: "/yemek/:subOrPagination?",
    component: _547b82d2,
    name: "/yemek___tr"
  }, {
    path: "/mobile/:slug?/view",
    component: _5778039d,
    name: "mobile-slug-view___tr"
  }, {
    path: "/profil/:username/ayarlar",
    component: _cb375fde,
    name: "profil-username-ayarlar___tr"
  }, {
    path: "/astroloji/:burc?/:slug?",
    component: _2a849156,
    name: "astroloji-burc-slug___tr"
  }, {
    path: "/mesaj/:username/:slug?",
    component: _3e48db2a,
    name: "mesaj-username-slug___tr"
  }, {
    path: "/vitrin/:slug/:pageNum?",
    component: _16ef6b7c,
    name: "vitrin-slug-pageNum___tr"
  }, {
    path: "/etiket/:tagName/:tagId/:pageNum?",
    component: _5c8fd7fd,
    name: "etiket-tagName-tagId-pageNum___tr"
  }, {
    path: "/seninmakyajin/*",
    component: _463c6b1f
  }, {
    path: "/demo/*",
    component: _463c6b1f
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index___tr"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
